import React from "react";
import Select from "react-select";
import {
  LEASING_REQUEST_STATUS_OPTIONS,
  LEASING_REQUEST_PURPOSE_OPTIONS,
  STATUS_OPTIONS,
} from "../constrant/leasing.ct.options";
import Button from "../components/leasing.c.button";
import classNames from "classnames";
import LoadingMutation from "../components/leasing.c.loadingMutation";
import { DatePicker } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { onChangeSearchBar } from "../../../_redux/searchBarSlice";
import { SubmitLocalStorageSearch } from "../../../function";

function FootageFilter({
  getDefaultQuery,
  refetch,
  onChangeFormQuery,
  onChangeSelect,
  formQuery,
  setFormQuery,
  onChangeFormDate,
  isTransfer,
  isLoan = false,
  setCurrentCountRecord,
}) {
  const dispatch = useDispatch();
  const searchBar = useSelector((state) => state.searchBar);

  const onSubmitFilter = async () => {
    try {
      await refetch(formQuery);
      setCurrentCountRecord(new Date().getTime());
      if (searchBar) {
        SubmitLocalStorageSearch(searchBar);
      }
    } catch (error) {
      console.log("submit filter error", error);
    }
  };

  const onClickClearFilter = async () => {
    try {
      dispatch(onChangeSearchBar(""));
      const defaultQuery = getDefaultQuery();
      await refetch(defaultQuery, true, false, "", "");
      setCurrentCountRecord(new Date().getTime());
      setFormQuery(defaultQuery);
    } catch (error) {
      console.log("clear filter error", error);
    }
  };

  const onClickRefetchFilter = async () => {
    try {
      await refetch(formQuery);
      setCurrentCountRecord(new Date().getTime());
    } catch (error) {
      console.log("reset filter error", error);
    }
  };

  const filterStatusOptions = () => {
    if (isLoan) {
      return STATUS_OPTIONS;
    }

    if (isTransfer) {
      return [
        LEASING_REQUEST_STATUS_OPTIONS[13],
        LEASING_REQUEST_STATUS_OPTIONS[14],
      ];
    }
    return LEASING_REQUEST_STATUS_OPTIONS;
  };

  return (
    <div className="w-full mt-2 mb-2 lg:flex items-center">
      <div className="lg:flex items-center ">
        <DatePicker
          allowClear={false}
          name="max"
          format={"DD-MM-YYYY"}
          value={formQuery.min ? moment(formQuery.min) : ""}
          onChange={onChangeFormDate("min")}
          defaultPickerValue={moment(new Date())}
        />
      </div>
      <div className="lg:flex items-center lg:ml-0">
        <div className="lg:ml-2 mr-2">To</div>
        <DatePicker
          allowClear={false}
          name="max"
          format={"DD-MM-YYYY"}
          value={formQuery.max ? moment(formQuery.max) : ""}
          onChange={onChangeFormDate("max")}
          defaultPickerValue={moment(new Date())}
        />
      </div>

      <div className="lg:ml-2 w-52 my-1">
        <Select
          value={formQuery.status}
          options={filterStatusOptions()}
          onChange={onChangeSelect("status")}
        />
      </div>
      <div className="my-1 lg:my-0 lg:ml-2 w-52">
        <Select
          value={formQuery.category}
          options={LEASING_REQUEST_PURPOSE_OPTIONS}
          onChange={onChangeSelect("category")}
        />
      </div>

      <button
        className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
        onClick={onSubmitFilter}
      >
        Submit
      </button>
      <button
        className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
        onClick={onClickClearFilter}
      >
        Clear
      </button>
      <svg
        onClick={onClickRefetchFilter}
        xmlns="http://www.w3.org/2000/svg"
        className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </div>
  );
}

export default FootageFilter;
